import { cache } from "react";
import { type Chain, createPublicClient, http } from "viem";
import {
  arbitrum,
  arbitrumSepolia,
  base,
  bsc,
  mainnet,
  optimism,
} from "viem/chains";

const chainConfigMap: Record<
  number,
  {
    rpcUrl?: string;
    chain: Chain;
  }
> = {
  [arbitrumSepolia.id]: {
    rpcUrl: process.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_RPC_URL,
    chain: arbitrumSepolia,
  },
  [arbitrum.id]: {
    rpcUrl: process.env.NEXT_PUBLIC_ARBITRUM_RPC_URL,
    chain: arbitrum,
  },
  [optimism.id]: {
    chain: optimism,
  },
  [base.id]: {
    chain: base,
  },
  [bsc.id]: {
    chain: bsc,
  },
  [mainnet.id]: {
    chain: mainnet,
  },
};

export const getPublicClient = cache(
  (chainId: number | string = arbitrum.id) => {
    const chainConfig = chainConfigMap[Number(chainId)];
    const chain = chainConfig?.chain || arbitrum;
    return createPublicClient({
      chain,
      transport: http(chainConfig.rpcUrl ?? chain.rpcUrls.default.http[0]),
      batch: {
        multicall: false,
      },
    });
  },
);
